// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__3WE3Z","spindindust":"Search_spindindust__2U96r"};